import React, { useState } from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import MaintenanceBannerSection from "./MaintenanceBannerSection";
import MobileVersionControlSection from "./MobileVersionControlSection";

function MaintenanceBannerAdminPage() {
	const [tab, setTab] = useState(0);

	return (
		<Box sx={{ p: 1 }}>
			<Tabs value={tab} onChange={(_, value) => setTab(value)} sx={{ mb: 2 }}>
				<Tab label="Maintenance Banner" />
				<Tab label="Mobile Version Control" />
			</Tabs>
			{tab === 0 && <MaintenanceBannerSection />}
			{tab === 1 && <MobileVersionControlSection />}
		</Box>
	);
}

export default MaintenanceBannerAdminPage;
